var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24, _clipPath25, _clipPath26, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.964706,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,78.039216%,0%)",
      fillOpacity: 1
    },
    d: "M 49.167969 4.765625 C 49.816406 4.597656 50.25 4.820312 50.464844 5.433594 C 50.574219 11.566406 50.617188 17.699219 50.601562 23.832031 C 50.429688 24.222656 50.132812 24.402344 49.699219 24.367188 C 49.222656 24.390625 48.921875 24.167969 48.800781 23.699219 C 48.695312 17.566406 48.648438 11.433594 48.667969 5.300781 C 48.757812 5.042969 48.921875 4.867188 49.167969 4.765625 Z M 49.167969 4.765625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.952941,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,95.686275%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 34.566406 11.367188 C 34.8125 11.355469 35.054688 11.367188 35.300781 11.398438 C 35.4375 11.453125 35.5625 11.53125 35.667969 11.632812 C 37.683594 15.511719 39.683594 19.402344 41.667969 23.300781 C 41.789062 24.246094 41.378906 24.65625 40.433594 24.535156 C 40.15625 24.433594 39.964844 24.246094 39.867188 23.964844 C 37.933594 20.1875 36 16.410156 34.066406 12.632812 C 33.902344 12.070312 34.070312 11.648438 34.566406 11.367188 Z M 34.566406 11.367188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.952941,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,95.686275%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 66.167969 11.367188 C 67.109375 11.277344 67.519531 11.699219 67.398438 12.632812 C 65.417969 16.53125 63.417969 20.421875 61.398438 24.300781 C 61.074219 24.550781 60.710938 24.628906 60.300781 24.535156 C 59.796875 24.265625 59.632812 23.851562 59.800781 23.300781 C 61.78125 19.402344 63.78125 15.511719 65.800781 11.632812 C 65.921875 11.535156 66.042969 11.445312 66.167969 11.367188 Z M 66.167969 11.367188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.94902,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,78.039216%,0%)",
      fillOpacity: 1
    },
    d: "M 19.699219 15.167969 C 20.03125 15.128906 20.339844 15.1875 20.632812 15.332031 C 24.890625 19.589844 29.144531 23.84375 33.398438 28.101562 C 33.664062 28.597656 33.605469 29.054688 33.234375 29.464844 C 32.832031 29.6875 32.433594 29.6875 32.035156 29.464844 C 27.777344 25.210938 23.523438 20.957031 19.265625 16.699219 C 18.933594 16.042969 19.078125 15.53125 19.699219 15.167969 Z M 19.699219 15.167969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.94902,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,78.039216%,0%)",
      fillOpacity: 1
    },
    d: "M 78.566406 15.167969 C 79.6875 15.136719 80.050781 15.648438 79.667969 16.699219 C 75.410156 20.957031 71.15625 25.210938 66.898438 29.464844 C 66.058594 29.835938 65.527344 29.578125 65.300781 28.699219 C 65.332031 28.480469 65.410156 28.28125 65.535156 28.101562 C 69.851562 23.75 74.195312 19.4375 78.566406 15.167969 Z M 78.566406 15.167969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,78.039216%,0.392157%)",
      fillOpacity: 1
    },
    d: "M 54.832031 77.035156 C 51.460938 77.113281 48.082031 77.113281 44.699219 77.035156 C 44.605469 76.234375 44.515625 75.433594 44.433594 74.632812 C 45.84375 74.800781 47.265625 75.011719 48.699219 75.265625 C 50.148438 75.476562 51.480469 75.183594 52.699219 74.398438 C 53.445312 73.71875 53.945312 72.886719 54.199219 71.898438 C 54.480469 70.523438 54.746094 69.148438 55 67.765625 C 55.257812 66.9375 55.59375 66.136719 56 65.367188 C 56.789062 64.011719 57.609375 62.675781 58.464844 61.367188 C 59.871094 59.511719 61.226562 57.625 62.535156 55.699219 C 63.992188 53.210938 64.992188 50.542969 65.535156 47.699219 C 65.734375 42.046875 63.566406 37.546875 59.035156 34.199219 C 56.441406 32.226562 53.574219 30.757812 50.433594 29.800781 C 46.398438 28.789062 42.488281 29.132812 38.699219 30.832031 C 42.414062 27.949219 46.636719 26.691406 51.367188 27.066406 C 54.851562 27.386719 58.003906 28.566406 60.832031 30.601562 C 66.914062 35.042969 69.390625 41.007812 68.265625 48.5 C 67.40625 53.085938 65.339844 57.019531 62.066406 60.300781 C 58.242188 65.242188 55.832031 70.820312 54.832031 77.035156 Z M 54.832031 77.035156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,95.294118%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 44.433594 74.632812 C 43.621094 69.457031 41.613281 64.8125 38.398438 60.699219 C 32.746094 55.984375 30.410156 49.964844 31.398438 42.632812 C 32.3125 37.734375 34.746094 33.800781 38.699219 30.832031 C 42.488281 29.132812 46.398438 28.789062 50.433594 29.800781 C 53.574219 30.757812 56.441406 32.226562 59.035156 34.199219 C 63.566406 37.546875 65.734375 42.046875 65.535156 47.699219 C 64.992188 50.542969 63.992188 53.210938 62.535156 55.699219 C 61.226562 57.625 59.871094 59.511719 58.464844 61.367188 C 57.609375 62.675781 56.789062 64.011719 56 65.367188 C 55.59375 66.136719 55.257812 66.9375 55 67.765625 C 54.746094 69.148438 54.480469 70.523438 54.199219 71.898438 C 53.945312 72.886719 53.445312 73.71875 52.699219 74.398438 C 51.480469 75.183594 50.148438 75.476562 48.699219 75.265625 C 47.265625 75.011719 45.84375 74.800781 44.433594 74.632812 Z M 44.433594 74.632812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.956863,
      stroke: "none"
    }
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface26",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,95.686275%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 83.632812 31.632812 C 84.761719 31.597656 85.128906 32.109375 84.734375 33.167969 C 84.640625 33.253906 84.539062 33.332031 84.433594 33.398438 C 80.363281 34.765625 76.296875 36.140625 72.234375 37.535156 C 71.289062 37.65625 70.878906 37.246094 71 36.300781 C 71.074219 36.070312 71.21875 35.902344 71.433594 35.800781 C 75.519531 34.441406 79.585938 33.054688 83.632812 31.632812 Z M 83.632812 31.632812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.956863,
      stroke: "none"
    }
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface29",
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,95.686275%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 15.035156 32.035156 C 15.277344 32.023438 15.523438 32.035156 15.765625 32.066406 C 19.910156 33.460938 24.042969 34.886719 28.167969 36.332031 C 28.417969 36.65625 28.496094 37.023438 28.398438 37.433594 C 28.132812 37.9375 27.71875 38.101562 27.167969 37.933594 C 23.171875 36.566406 19.171875 35.210938 15.167969 33.867188 C 14.507812 33.585938 14.320312 33.105469 14.601562 32.433594 C 14.738281 32.285156 14.882812 32.152344 15.035156 32.035156 Z M 15.035156 32.035156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface32",
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,78.039216%,0%)",
      fillOpacity: 1
    },
    d: "M 10.101562 44.964844 C 16.300781 44.957031 22.5 44.964844 28.699219 45 C 29.085938 45.175781 29.265625 45.476562 29.234375 45.898438 C 29.261719 46.328125 29.082031 46.625 28.699219 46.800781 C 22.5 46.84375 16.300781 46.84375 10.101562 46.800781 C 9.714844 46.625 9.539062 46.328125 9.566406 45.898438 C 9.550781 45.472656 9.726562 45.160156 10.101562 44.964844 Z M 10.101562 44.964844 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface35",
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,78.039216%,0%)",
      fillOpacity: 1
    },
    d: "M 71.765625 44.964844 C 77.964844 44.957031 84.167969 44.964844 90.367188 45 C 90.753906 45.175781 90.929688 45.476562 90.898438 45.898438 C 90.929688 46.328125 90.75 46.625 90.367188 46.800781 C 84.167969 46.84375 77.964844 46.84375 71.765625 46.800781 C 71.382812 46.625 71.207031 46.328125 71.234375 45.898438 C 71.21875 45.472656 71.394531 45.160156 71.765625 44.964844 Z M 71.765625 44.964844 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.956863,
      stroke: "none"
    }
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface38",
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,95.686275%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 26.765625 56.566406 C 27.898438 56.53125 28.261719 57.042969 27.867188 58.101562 C 27.773438 58.1875 27.671875 58.261719 27.566406 58.332031 C 23.496094 59.699219 19.429688 61.074219 15.367188 62.464844 C 14.421875 62.589844 14.011719 62.179688 14.132812 61.234375 C 14.207031 61.003906 14.351562 60.835938 14.566406 60.734375 C 18.652344 59.375 22.71875 57.988281 26.765625 56.566406 Z M 26.765625 56.566406 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.956863,
      stroke: "none"
    }
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface41",
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,95.686275%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 71.101562 56.964844 C 71.34375 56.957031 71.589844 56.964844 71.832031 57 C 75.976562 58.394531 80.109375 59.816406 84.234375 61.265625 C 84.484375 61.589844 84.5625 61.957031 84.464844 62.367188 C 84.199219 62.867188 83.785156 63.035156 83.234375 62.867188 C 79.171875 61.476562 75.105469 60.097656 71.035156 58.734375 C 70.703125 58.542969 70.546875 58.253906 70.566406 57.867188 C 70.5625 57.457031 70.742188 57.160156 71.101562 56.964844 Z M 71.101562 56.964844 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.94902,
      stroke: "none"
    }
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface44",
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,78.039216%,0%)",
      fillOpacity: 1
    },
    d: "M 33.167969 62.765625 C 34.285156 62.738281 34.652344 63.25 34.265625 64.300781 C 30.011719 68.554688 25.753906 72.8125 21.5 77.066406 C 20.441406 77.453125 19.941406 77.085938 20 75.964844 C 20.042969 75.878906 20.089844 75.789062 20.132812 75.699219 C 24.449219 71.347656 28.792969 67.039062 33.167969 62.765625 Z M 33.167969 62.765625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.94902,
      stroke: "none"
    }
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface47",
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,78.039216%,0%)",
      fillOpacity: 1
    },
    d: "M 67.035156 64.167969 C 67.363281 64.128906 67.675781 64.1875 67.964844 64.332031 C 72.222656 68.589844 76.476562 72.84375 80.734375 77.101562 C 80.996094 77.597656 80.941406 78.054688 80.566406 78.464844 C 80.167969 78.6875 79.765625 78.6875 79.367188 78.464844 C 75.113281 74.210938 70.855469 69.957031 66.601562 65.699219 C 66.269531 65.042969 66.414062 64.53125 67.035156 64.167969 Z M 67.035156 64.167969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.952941,
      stroke: "none"
    }
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface50",
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,95.686275%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 60.433594 70.367188 C 60.820312 70.304688 61.164062 70.394531 61.464844 70.632812 C 63.820312 74.320312 66.179688 78.011719 68.535156 81.699219 C 68.65625 82.644531 68.246094 83.054688 67.300781 82.933594 C 67.160156 82.878906 67.039062 82.800781 66.933594 82.699219 C 64.578125 79.011719 62.222656 75.320312 59.867188 71.632812 C 59.699219 71.039062 59.886719 70.617188 60.433594 70.367188 Z M 60.433594 70.367188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.952941,
      stroke: "none"
    }
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface53",
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,95.686275%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 38.765625 70.433594 C 39.898438 70.398438 40.261719 70.90625 39.867188 71.964844 C 37.464844 75.523438 35.066406 79.078125 32.667969 82.632812 C 32.34375 82.886719 31.976562 82.964844 31.566406 82.867188 C 31 82.484375 30.878906 81.984375 31.199219 81.367188 C 33.558594 77.917969 35.894531 74.453125 38.199219 70.964844 C 38.339844 70.726562 38.527344 70.550781 38.765625 70.433594 Z M 38.765625 70.433594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface56",
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(68.235294%,68.235294%,67.843137%)",
      fillOpacity: 1
    },
    d: "M 44.699219 77.035156 C 48.082031 77.113281 51.460938 77.113281 54.832031 77.035156 C 55.023438 77.386719 55.078125 77.765625 55 78.167969 C 54.953125 78.304688 54.875 78.417969 54.765625 78.5 C 51.433594 78.5 48.101562 78.5 44.765625 78.5 C 44.601562 78.289062 44.535156 78.046875 44.566406 77.765625 C 44.558594 77.511719 44.601562 77.265625 44.699219 77.035156 Z M 44.699219 77.035156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface59",
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.843137%,68.235294%,67.843137%)",
      fillOpacity: 1
    },
    d: "M 44.765625 79.234375 C 48.101562 79.234375 51.433594 79.234375 54.765625 79.234375 C 54.984375 79.425781 55.074219 79.667969 55.035156 79.964844 C 55.074219 80.265625 54.984375 80.507812 54.765625 80.699219 C 51.433594 80.699219 48.101562 80.699219 44.765625 80.699219 C 44.601562 80.492188 44.535156 80.246094 44.566406 79.964844 C 44.535156 79.6875 44.601562 79.441406 44.765625 79.234375 Z M 44.765625 79.234375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface62",
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.843137%,67.843137%,67.843137%)",
      fillOpacity: 1
    },
    d: "M 44.765625 81.433594 C 48.101562 81.433594 51.433594 81.433594 54.765625 81.433594 C 54.855469 81.761719 54.84375 82.09375 54.734375 82.433594 C 54.617188 82.648438 54.449219 82.804688 54.234375 82.898438 C 51.164062 82.921875 48.097656 82.898438 45.035156 82.832031 C 44.808594 82.753906 44.664062 82.597656 44.601562 82.367188 C 44.554688 82.121094 44.554688 81.878906 44.601562 81.632812 C 44.625 81.539062 44.679688 81.46875 44.765625 81.433594 Z M 44.765625 81.433594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface65",
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(59.607843%,59.215686%,59.215686%)",
      fillOpacity: 1
    },
    d: "M 45.035156 82.832031 C 48.097656 82.898438 51.164062 82.921875 54.234375 82.898438 C 54.078125 83.167969 53.921875 83.433594 53.765625 83.699219 C 50.964844 83.613281 48.167969 83.613281 45.367188 83.699219 C 45.238281 83.417969 45.125 83.128906 45.035156 82.832031 Z M 45.035156 82.832031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface68",
    clipPath: "url(#clip22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.843137%,67.843137%,67.843137%)",
      fillOpacity: 1
    },
    d: "M 53.765625 83.699219 C 53.707031 84.242188 53.484375 84.707031 53.101562 85.101562 C 53.046875 85.160156 52.976562 85.179688 52.898438 85.167969 C 50.671875 85.1875 48.449219 85.164062 46.234375 85.101562 C 45.992188 84.847656 45.757812 84.578125 45.535156 84.300781 C 45.40625 84.121094 45.351562 83.917969 45.367188 83.699219 C 48.167969 83.613281 50.964844 83.613281 53.765625 83.699219 Z M 53.765625 83.699219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface71",
    clipPath: "url(#clip23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(59.607843%,59.215686%,59.215686%)",
      fillOpacity: 1
    },
    d: "M 46.234375 85.101562 C 48.449219 85.164062 50.671875 85.1875 52.898438 85.167969 C 52.804688 85.378906 52.695312 85.578125 52.566406 85.765625 C 50.613281 85.855469 48.65625 85.855469 46.699219 85.765625 C 46.492188 85.582031 46.335938 85.359375 46.234375 85.101562 Z M 46.234375 85.101562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.980392,
      stroke: "none"
    }
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface74",
    clipPath: "url(#clip24)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.843137%,67.843137%,67.843137%)",
      fillOpacity: 1
    },
    d: "M 46.699219 85.765625 C 48.65625 85.855469 50.613281 85.855469 52.566406 85.765625 C 52.59375 86.03125 52.539062 86.273438 52.398438 86.5 C 52.234375 86.746094 52.066406 86.988281 51.898438 87.234375 C 51.828125 87.3125 51.738281 87.359375 51.632812 87.367188 C 50.355469 87.378906 49.066406 87.355469 47.765625 87.300781 C 47.34375 86.964844 47 86.566406 46.734375 86.101562 C 46.699219 85.992188 46.6875 85.878906 46.699219 85.765625 Z M 46.699219 85.765625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.964706,
      stroke: "none"
    }
  }))), _clipPath25 || (_clipPath25 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface77",
    clipPath: "url(#clip25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(59.607843%,59.215686%,59.215686%)",
      fillOpacity: 1
    },
    d: "M 47.765625 87.300781 C 49.066406 87.355469 50.355469 87.378906 51.632812 87.367188 C 51.523438 87.542969 51.410156 87.722656 51.300781 87.898438 C 50.277344 87.988281 49.253906 87.988281 48.234375 87.898438 C 48.054688 87.71875 47.898438 87.519531 47.765625 87.300781 Z M 47.765625 87.300781 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.956863,
      stroke: "none"
    }
  }))), _clipPath26 || (_clipPath26 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface80",
    clipPath: "url(#clip26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.843137%,67.843137%,67.843137%)",
      fillOpacity: 1
    },
    d: "M 51.300781 87.898438 C 51.238281 88.511719 51.027344 89.066406 50.667969 89.566406 C 50.285156 89.976562 49.832031 90.078125 49.300781 89.867188 C 48.726562 89.328125 48.371094 88.671875 48.234375 87.898438 C 49.253906 87.988281 50.277344 87.988281 51.300781 87.898438 Z M 51.300781 87.898438 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,99.607843%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 45.433594 30.367188 C 45.792969 30.335938 46.113281 30.425781 46.398438 30.632812 C 46.746094 31.136719 46.691406 31.589844 46.234375 32 C 41.382812 33.402344 38.171875 36.503906 36.601562 41.300781 C 35.980469 41.882812 35.445312 41.816406 35 41.101562 C 34.957031 40.921875 34.957031 40.746094 35 40.566406 C 36.777344 35.421875 40.257812 32.023438 45.433594 30.367188 Z M 45.433594 30.367188 "
  }), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface26",
    mask: "url(#mask7)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface29",
    mask: "url(#mask8)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(29.803922%,80%,59.607843%)",
      fillOpacity: 1
    },
    d: "M 58.964844 42.765625 C 58.578125 42.371094 58.15625 42.003906 57.699219 41.667969 C 56.417969 41.15625 55.21875 41.3125 54.101562 42.132812 C 53.113281 42.988281 52.324219 44 51.734375 45.167969 C 50.9375 47.136719 50.3125 49.15625 49.867188 51.234375 C 49.347656 52.332031 48.492188 53.007812 47.300781 53.265625 C 46.523438 53.382812 45.746094 53.394531 44.964844 53.300781 C 43.300781 51.175781 42.933594 48.839844 43.867188 46.300781 C 44.453125 44.582031 45.441406 43.148438 46.832031 42 C 49.21875 40.132812 51.929688 39.265625 54.964844 39.398438 C 56.882812 39.835938 58.214844 40.960938 58.964844 42.765625 Z M 58.964844 42.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(1.176471%,49.803922%,45.098039%)",
      fillOpacity: 1
    },
    d: "M 58.964844 42.765625 C 59.074219 42.875 59.054688 42.941406 58.898438 42.964844 C 57.292969 42.574219 55.859375 42.90625 54.601562 43.964844 C 54.449219 44.199219 54.316406 44.445312 54.199219 44.699219 C 54.097656 45.742188 54.195312 46.765625 54.5 47.765625 C 54.558594 48.082031 54.667969 48.371094 54.832031 48.632812 C 55.113281 50.84375 54.332031 52.566406 52.5 53.800781 C 51.441406 54.472656 50.308594 54.984375 49.101562 55.332031 C 49.730469 57.296875 50.144531 59.304688 50.332031 61.367188 C 50.390625 61.839844 50.371094 62.304688 50.265625 62.765625 C 50.144531 63.011719 49.957031 63.167969 49.699219 63.234375 C 49.5625 60.566406 49.0625 57.964844 48.199219 55.433594 C 47.863281 55.429688 47.519531 55.417969 47.167969 55.398438 C 47.082031 55.347656 46.996094 55.3125 46.898438 55.300781 C 46.117188 54.761719 45.472656 54.09375 44.964844 53.300781 C 45.746094 53.394531 46.523438 53.382812 47.300781 53.265625 C 48.492188 53.007812 49.347656 52.332031 49.867188 51.234375 C 50.3125 49.15625 50.9375 47.136719 51.734375 45.167969 C 52.324219 44 53.113281 42.988281 54.101562 42.132812 C 55.21875 41.3125 56.417969 41.15625 57.699219 41.667969 C 58.15625 42.003906 58.578125 42.371094 58.964844 42.765625 Z M 58.964844 42.765625 "
  }), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface32",
    mask: "url(#mask9)"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface35",
    mask: "url(#mask10)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(31.764706%,72.941176%,53.333333%)",
      fillOpacity: 1
    },
    d: "M 54.5 47.765625 C 54.664062 48.03125 54.777344 48.320312 54.832031 48.632812 C 54.667969 48.371094 54.558594 48.082031 54.5 47.765625 Z M 54.5 47.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(30.196078%,79.607843%,59.215686%)",
      fillOpacity: 1
    },
    d: "M 46.898438 55.300781 C 46.996094 55.3125 47.082031 55.347656 47.167969 55.398438 C 47.519531 55.417969 47.863281 55.429688 48.199219 55.433594 C 49.0625 57.964844 49.5625 60.566406 49.699219 63.234375 C 49.210938 63.179688 48.890625 62.914062 48.734375 62.433594 C 48.855469 60.949219 48.742188 59.480469 48.398438 58.035156 C 48.074219 57.023438 47.574219 56.109375 46.898438 55.300781 Z M 46.898438 55.300781 "
  }), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface38",
    mask: "url(#mask11)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface41",
    mask: "url(#mask12)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface44",
    mask: "url(#mask13)"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface47",
    mask: "url(#mask14)"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface50",
    mask: "url(#mask15)"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface53",
    mask: "url(#mask16)"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface56",
    mask: "url(#mask17)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(59.215686%,59.215686%,58.823529%)",
      fillOpacity: 1
    },
    d: "M 44.765625 78.5 C 48.101562 78.5 51.433594 78.5 54.765625 78.5 C 54.765625 78.746094 54.765625 78.988281 54.765625 79.234375 C 51.433594 79.234375 48.101562 79.234375 44.765625 79.234375 C 44.765625 78.988281 44.765625 78.746094 44.765625 78.5 Z M 44.765625 78.5 "
  }), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface59",
    mask: "url(#mask18)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(59.215686%,59.215686%,58.823529%)",
      fillOpacity: 1
    },
    d: "M 44.765625 80.699219 C 48.101562 80.699219 51.433594 80.699219 54.765625 80.699219 C 54.765625 80.945312 54.765625 81.1875 54.765625 81.433594 C 51.433594 81.433594 48.101562 81.433594 44.765625 81.433594 C 44.765625 81.1875 44.765625 80.945312 44.765625 80.699219 Z M 44.765625 80.699219 "
  }), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface62",
    mask: "url(#mask19)"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface65",
    mask: "url(#mask20)"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface68",
    mask: "url(#mask21)"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface71",
    mask: "url(#mask22)"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface74",
    mask: "url(#mask23)"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface77",
    mask: "url(#mask24)"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface80",
    mask: "url(#mask25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.a36ed146d303d2808bb9354d4ab38576.svg";
export { ForwardRef as ReactComponent };